<template>
  <div class="s-information-detail-container">
    <topNav></topNav>
    <div class="s-information-top">
      <div class="banner w1300 marginAuto"></div>
    </div>
    <div class="s-information-detail w1300">
      <div class="s-information-detail-down">
        <div class="s-information-detail-title">
          {{ infoDetail.informationTitle }}
        </div>
        <div class="s-information-detail-sub">
          <div class="s-information-date">
            时间：{{ infoDetail.uploadDate }}
          </div>
          <div class="s-information-source">
            来源：{{ infoDetail.dataSources }}
          </div>
        </div>
      </div>
      <div class="s-information-detail-img marginAuto">
        <!-- <img :src="imgUrlBank" class="bankLogo" /> -->
      </div>
      <div class="s-information-detail-info" v-html="infoDetail.informationDetailStr">
      </div>
    </div>
    <footer-nav></footer-nav>
  </div>
</template>

<script>
import topNav from "../components/topNav.vue";
import footerNav from "../components/footerNav.vue";
import { informationDetail } from "./../utils/api/index";
export default {
  name: "informationDetail",
  components: { topNav, footerNav },
  data() {
    return {
      id: "",
      pageType: "",
      infoDetail: {},
      imgUrlBank: "",
      defaultImg: require("../assets/image/dealmakers/default.png"),
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.pageType = this.$route.query.pageType;
    this.informationDetail();
  },
  methods: {
    async informationDetail() {
      let params = {
        id: this.id,
      };
      let res = await informationDetail(params);
      if (res.data.code === 0) {
        this.infoDetail = res.data.data;
        if (this.infoDetail.img != null) {
          this.imgUrlBank =
            this.imgURL + "/" + this.infoDetail.img.split(",")[0];
        }
      }
    },
  },
};
</script>
<style lang="scss">
@import "../utils/css/common.scss";
@import "../utils/css/informationDetail.scss";
</style>
<style lang="scss" scoped></style>